// Mirrors ThirdPartyIntegration/Tp_Communication/Enum/AssignmentStatusEnum.cs
// (numeric values are not contiguous — keep them in sync with the backend enum).
const AssignmentStatusEnum = {
  Created: 0,
  New: 1,
  Incomplete: 2,
  Completed: 3,
  CollaborationShop: 4,
  Excluded: 5,
  HoldA: 6,
  HoldB: 7,
  Reviewed: 8,
  Finalized: 9,
  Emailed: 10,
  ClientFinalized: 12,
  Locked: 15,
  DeletedInApollo: 23,
};

// Returns the enum name for a numeric value (e.g. 3 -> 'Completed'). Empty string for
// null/undefined; the raw value (as string) for an unknown number.
export const getAssignmentStatusName = (value) => {
  if (value === null || value === undefined || value === '') return '';
  const match = Object.entries(AssignmentStatusEnum).find(([, enumValue]) => enumValue === value);
  return match ? match[0] : String(value);
};

export default AssignmentStatusEnum;
